import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {PropertyService} from '../forms/services/property.service';
import {PropertyModel} from '../forms/models/property-model';

@Injectable({
    providedIn: 'root'
})
export class QuestionService {

    textContent = new Map<string, string>();

    constructor(private http: HttpClient,
                private propertyService: PropertyService) {
    }


    putContent(key: string, content: string) {
        const temp: PropertyModel = {
            id: "",
            dtype: "questions",

            dkey: key,
            dtext: content,
            language: 'DE',

        }
        this.propertyService.postProperties(temp)
    }

    async getContent(key: string) {
        const value = await this.propertyService.getPropertiesByKey(key).then(value1 => {
            return value1;
        });

        return value;
    }

}
